import styled from "styled-components";
import imgBanner from "../../assets/images/banner.png"
import { Link, useLocation } from "react-router-dom";
import { useDisconnect, useSwitchNetwork, useWeb3Modal, useWeb3ModalAccount, useWeb3ModalProvider } from "@web3modal/ethers/react";
import { User, UserAvatar, UserName } from "../cards/user";
import SettingsIcon from "@mui/icons-material/SettingsOutlined";
import { useUserInfo } from "../../hooks/user";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Avatar, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, IconButton, InputBase, InputLabel, Typography, useMediaQuery } from "@mui/material";
import EditIcon from "@mui/icons-material/BorderColorOutlined";
import CloseIcon from "@mui/icons-material/Close";
import LogoutIcon from '@mui/icons-material/Logout';
import DollarIcon from '@mui/icons-material/MonetizationOn';
import CopyIcon from '@mui/icons-material/ContentCopy';
import LinkIcon from '@mui/icons-material/OpenInNewOutlined';
import ArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeftOutlined';
import copy from 'copy-to-clipboard';
import { toast } from "react-toastify";
import { BrowserProvider, Eip1193Provider, ethers } from "ethers";
import axios from "axios";
import { FILE_ENDPOINT, API_ENDPOINT } from "../../abis/constants";
import { useNewTrades } from "../../hooks/token";
import { priceFormatter } from "../tvchart/chart";
import TokenLogo from "../tokenLogo";
import { socket } from "../../utils/socket";
import imgLogo from '../../assets/images/logo.png';
import { CubeIcon, DialogHowItWorks, HomeIcon, TokenIcon, WalletIcon } from "./sidebar";
import { useChainInfo, useContractInfo, useSwitchChain } from "../../hooks/config";

const HeaderBox = styled.div`
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100vw;
    z-index: 2;
    background: #121212;
`

const Flex = styled.div`
    display: flex;
    padding: 20px 16px;
    align-items: center;
    gap: 40px;
`

const LogoWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
`

const Banner = styled.div`
    overflow: hidden;
    background: black;
    border-radius: 16px;
    border: 1px solid #9998;
    width: 410px;
    flex: 0 0 411px;
    // position: fixed;
    top: 14px;
    z-index: 2;
    box-shadow: 0 0 10px #0008;
`

const StyledButton = styled.button`
    padding: 0 16px;
    height: 42px;
    padding: 12px 16px;
    background: rgba(255, 255, 255, 0.1);
    border: none;
    border-radius: 8px;
    color: white;
    font-size: 16px;
    font-family: Arial;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0%;
    cursor: pointer;
    display: flex;
    gap: 8px;
    align-items: center;
    &:hover {
        opacity: 0.7;
    }
    svg {
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        fill: currentColor;
    }
`

const StyledDropdownButton = styled.div`
    position: relative;
    & > div {
        position: absolute;
        display: none;
        top: 100%;
        right: 0;
        &::before {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin-top: 4px;
            content: "";
            background: rgba(255, 255, 255, 0.1);
            border-radius: 8px;
        }
        padding: 8px 0;
        min-width: 200px;
        z-index: 3;
        ${StyledButton} {
            background: none;
            border-radius: 0;
            &:hover {
                background: rgba(255, 255, 255, 0.1);
            }
        }
    }
    &:not(.done):hover > div {
        display: flex;
        flex-direction: column;
    }
`

const Buttons = styled.div`
    display: flex;
    gap: 8px;
    white-space: nowrap;
    justify-content: flex-end;
`

const AvatarWrapper = styled(Box)`
  position: relative;
  display: inline-block;
  & > label {
    position: absolute;
    right: 0;
    bottom: 0;
  }
`

const HiddenInput = styled("input")`
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1;
`

const FitDialog = styled(Dialog)`
    & .MuiDialog-paper {
        width: fit-content;
    }
`

const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "label + &": {
        marginTop: '1rem',
    },
    "& .MuiInputBase-input": {
        borderRadius: "16px",
        position: "relative",
        backgroundColor: "#FFFFFF0F",
        border: "none",
        padding: "10px 20px",
    },
}))

const TradeBox = styled(Box)`
    @keyframes stretch {
        from { transform: translateX(100%) }
        to { transform: translateX(0) }
    }
    &.new {
        animation: stretch 0.8s;
    }
`

function Trade({ trade, className }: any) {
    return <TradeBox
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        gap="8px"
        bgcolor="white"
        p="2px 8px"
        borderRadius="4px"
        className={className}
    >
        <User user={trade.user} address={trade.swapperAddress} size={25} color="black" mr={0} />
        <Typography
            sx={{ textWrap: "nowrap" }}
            color={trade.type === "BUY" ? "green" : "red"}
            fontSize={14}
        >
            {trade.type === "BUY" ? "Bought" : "Sold"}{" "}
        </Typography>
        <Typography
            sx={{ textWrap: "nowrap" }}
            fontSize={14}
        >
            {priceFormatter(trade.tokenAmount, 2, true, true)}
        </Typography>
        <Link
            to={`/${trade.network}/${trade.tokenAddress}`}
            style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: "8px" }}
        >
            {!FILE_ENDPOINT ? (
                <Avatar sx={{ width: 25, height: 25, ml: "0.5rem" }} />
            ) : (
                <TokenLogo
                    style={{ width: 25, height: 25, ml: "0.5rem" }}
                    logo={trade.tokenImage}
                />
            )}
            <Typography
                sx={{ textWrap: "nowrap" }}
                fontSize={14}
            >
                {trade.tokenSymbol}
            </Typography>
        </Link>
    </TradeBox>
}

export default function Header() {
    const { open } = useWeb3Modal()
    const { address, isConnected } = useWeb3ModalAccount()
    const { disconnect } = useDisconnect()
    const [loading, setLoading] = useState<string>()
    const { walletProvider } = useWeb3ModalProvider()
    // const { disconnect } = useDisconnect()
    const { userInfo, setUserInfo } = useUserInfo()
    const [modal, setModal] = useState<string>()
    const [userName, setUserName] = useState<string>()
    const [userBio, setUserBio] = useState<string>()
    const [avatar, setAvatar] = useState<any>()
    const fileRef = useRef<any>()
    const dropdownRef = useRef<any>()
    const [scrollTop, setScrollTop] = useState(0)
    // const [deployedToken, setDeployedToken] = useState<any>()
    // const [tradeIndex, setTradeIndex] = useState(0)
    // const [trades, setTrades] = useState<any[]>([])

    const { chain, chains } = useChainInfo()
    const { isWrongChain, isSwitching, switchChain } = useSwitchChain()

    const location = useLocation()

    const isDashboard = useMemo(() => location?.pathname === '/', [location])

    const isMobile = useMediaQuery('(max-width: 800px)')

    // const { trades: newTrades, reload: reloadTrades } = useNewTrades()

    const handleAvatar = (e: any) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            setAvatar(reader.result);
        };
        reader.readAsDataURL(file);
    }

    const uploadLogo = async (img: any) => {
        let formData = new FormData(); // instantiate it
        // suppose you have your file ready
        formData.set("image", img);
        // add some data you collected from the input fields
        const r = axios.post(`${API_ENDPOINT}/tokens/upload`, formData, {
            headers: {
                "api-key": "hola",
                "content-type": "multipart/form-data", // do not forget this
            },
        });

        return r;
    }

    const handleSaveProfile = useCallback(async () => {
        try {
            setLoading("profile");
            const user: any = {
                userAddress: address,
                username: userName ?? userInfo?.name ?? "",
                bio: userBio ?? userInfo?.bio,
            };
            if (avatar && fileRef.current.files?.length) {
                const img = fileRef.current.files[0];
                const extension = img.name.split(".").pop();
                if (
                    extension &&
                    !["jpg", "jpeg", "png"].includes(extension.toLowerCase())
                ) {
                    toast.error("Only jpg, jpeg, png files are allowed");
                    setLoading(undefined);
                    return;
                }
                // get file size
                if (img.size > 1024 * 1024) {
                    toast.error("File size should be less than 1MB");
                    setLoading(undefined);
                    return;
                }

                ///const ipfsResult = await uploadImageToIPFS(fileRef.current.files[0])
                const logoUploadResult = await uploadLogo(img);
                console.log(logoUploadResult);
                user.avatar = logoUploadResult.data.file.filename;
                //user.avatar = ipfsResult?.IpfsHash
            }
            // update userInfo
            const refCode = localStorage.getItem("referral");
            const provider = new BrowserProvider(walletProvider as Eip1193Provider);
            const signer = await provider.getSigner();
            const msg = Buffer.from(ethers.randomBytes(24)).toString("hex");
            const signature = await signer.signMessage(msg);
            await axios
                .post(`${API_ENDPOINT}/users${userInfo?.id ? "/update" : ""}`, {
                    user,
                    signature,
                    msg,
                    refCode,
                })
                .then(({ data }) => {
                    if (data) {
                        setUserInfo(data);
                        setModal(undefined);
                        localStorage.removeItem("referral");
                    }
                });
        } catch (err: any) {
            console.error(err);
            toast.error(err.response.data.error);
        }
        setLoading(undefined);
    }, [address, userName, userInfo, userBio, avatar, walletProvider, setUserInfo])

    const handleSwitch = (chainId: number) => {
        switchChain(chainId)
        dropdownRef.current.classList.add('done')
        setTimeout(() => dropdownRef.current.classList.remove('done'), 1000)
    }

    useEffect(() => {
        setUserName(undefined)
        setUserBio(undefined)
        setAvatar(undefined)
    }, [userInfo])

    useEffect(() => {
        setScrollTop(window.scrollY)
        window.addEventListener('scroll', function () {
            setScrollTop(window.scrollY)
        })
    }, [])    

    useEffect(() => {
        socket?.on("deployed", (data: any) => {
            const token = JSON.parse(data);
            if (token.creatorAddress === address) {
                const link = `${chain?.explorerUrl}/tx/${token.txHash}`
                toast.success(
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <span>Token {token.tokenSymbol} deployed!</span>
                        <a style={{ textDecoration: 'none', color: '#DDD', display: 'flex', alignItems: 'center' }} target="_blank" rel="noreferrer" href={link}>
                            See tx in explorer <LinkIcon sx={{ fontSize: 14, color: '#DDD' }} />
                        </a>
                    </div>, {
                        // onClick: () => {
                        //     setDeployedToken(token);
                        //     setModal('deployed')
                        // }
                    }
                )
            }
        })
        return () => {
            socket?.off('deployed')
        }
    }, [address])

    // useEffect(() => {
    //     if (newTrades) {
    //         setTrades((t) => {
    //             if (t.length === 0) {
    //                 setTradeIndex(newTrades.length)
    //                 return newTrades
    //             }
    //             return [...t, ...newTrades]
    //         })
    //     }
    // }, [newTrades])

    // useEffect(() => {
    //     if (trades.length > tradeIndex) {
    //         const timer = setTimeout(() => {
    //             setTradeIndex(i => i + 1);
    //         }, 1000);
    //         return () => clearTimeout(timer);
    //     }
    // }, [trades, tradeIndex])

    // useEffect(() => {
    //     socket.on("message", () => {
    //         reloadTrades();
    //     })
    //     return () => {
    //         socket.off("message");
    //     }
    // }, [reloadTrades]);

    if (isMobile)
        return <HeaderBox>
            <Flex style={{ paddingTop: '17px', paddingRight: '15px', justifyContent: 'flex-end' }}>
                <Buttons>
                    <Link to="/create" style={{ textDecoration: 'none' }}>
                        <StyledButton className="effect-button">Create Token</StyledButton>
                    </Link>
                    <Link to="/" style={{ textDecoration: 'none' }}>
                        <LogoWrapper style={{ width: "42px" }}>
                            <img src={imgLogo} style={{ alignSelf: 'center', objectFit: 'cover' }} width={82} height={82} alt="logo" />
                        </LogoWrapper>
                    </Link>
                </Buttons>
            </Flex>
            {/* {
                location?.pathname !== '/create' && tradeIndex > 0 && trades.length > 0 &&
                <Box display="flex" justifyContent="center" gap="8px" py="8px" alignItems="stretch">
                    <Trade trade={trades[tradeIndex - 1]} className="new" />
                </Box>
            } */}
        </HeaderBox>

    return <div>
        {/* {
            location?.pathname !== '/create' && 
            <Box overflow="hidden" py="8px" pr="8px" minHeight="29px">
                <Box display="flex" justifyContent="flex-end" gap="8px" px="16px" ml="-13px" mr="-15px" alignItems="center">
                    {
                        trades.slice(Math.max(0, tradeIndex - 10), tradeIndex).map(trade =>
                            <Trade trade={trade} key={trade.id} className={trade.id === trades[tradeIndex - 1].id ? "new" : ""} />
                        )
                    }
                </Box>
            </Box>
        } */}
        {
            isDashboard &&
            <Banner style={{ position: "fixed", height: `${Math.max(58, 139 - scrollTop)}px`, marginLeft: "16px" }}>
                <img src={imgBanner} height="100%" alt="" />
            </Banner>
        }
        <Flex style={{ justifyContent: "space-between", height: "130px", paddingRight: "16px" }}>
            {
                isDashboard
                    ? <div />
                    : <Banner style={{ height: 139 }}>
                        <img src={imgBanner} height="100%" alt="" />
                    </Banner>
            }
            <Box alignSelf="flex-start">
                <Buttons>
                    <Link to="/" style={{ textDecoration: 'none' }}>
                        <StyledButton className="effect-button">
                            <HomeIcon />
                        </StyledButton>
                    </Link>
                    <StyledButton className="effect-button" onClick={() => setModal('how')}>
                        <CubeIcon />
                        How it works
                    </StyledButton>
                    {
                        isConnected
                            ? isWrongChain
                                ? <StyledButton onClick={() => switchChain(chain?.chainId)} className="effect-button">
                                    { isSwitching ? <CircularProgress color="inherit" size={20} /> : <WalletIcon /> }
                                    Switch Network
                                </StyledButton>
                                : <StyledDropdownButton ref={dropdownRef}>
                                    <StyledButton className="effect-button">
                                        {/* <WalletIcon /> */}
                                        <User
                                            user={userInfo}
                                            address={address}
                                            me
                                            mr={0}
                                            fontSize="12px"
                                            color="white"
                                        />
                                        {
                                            isSwitching 
                                            ? <CircularProgress color="inherit" size={20} /> 
                                            : <img src={`/networks/${chain?.network}.svg`} alt="" height={24} />
                                        }
                                    </StyledButton>
                                    <div>
                                        {
                                            chains?.map(c => 
                                                <StyledButton key={`chain-${c.chainId}`} className="effect-button" onClick={() => handleSwitch(c.chainId)}>
                                                    <img src={`/networks/${c.network}.svg`} alt="" height={24} />
                                                    {c.name}
                                                </StyledButton>
                                            )
                                        }
                                        <StyledButton className="effect-button" onClick={() => disconnect()}>
                                            <LogoutIcon sx={{ color: "white" }} />
                                            Disconnect
                                        </StyledButton>
                                    </div>
                                    {/* <SettingsIcon sx={{ color: "white", ml: 1 }} /> */}
                                </StyledDropdownButton>
                            : <StyledButton onClick={() => open()} className="effect-button">
                                <WalletIcon />
                                Connect Wallet
                            </StyledButton>
                    }
                </Buttons>
            </Box>
        </Flex>
        <DialogHowItWorks open={modal === 'how'} onClose={() => setModal(undefined)} />
        <Dialog
            open={modal === "profile"}
            fullWidth
            // TransitionComponent={Transition}
            keepMounted
            onClose={loading === "profile" ? () => { } : () => setModal(undefined)}
        >
            <DialogTitle>
                {userInfo ? "Edit" : "Create"} profile
                {loading !== "profile" && (
                    <IconButton onClick={() => setModal(undefined)}>
                        <CloseIcon sx={{ color: "#9E9E9E" }} />
                    </IconButton>
                )}
            </DialogTitle>
            <DialogContent>
                <div>
                    <AvatarWrapper>
                        {avatar ? (
                            <Avatar sx={{ width: 94, height: 94 }} src={avatar} />
                        ) : (
                            <UserAvatar size={94} user={userInfo} address={address} />
                        )}
                        <IconButton
                            sx={{ bgcolor: "#E12D85", "&:hover": { bgcolor: "#E12D8588" } }}
                            component="label"
                        >
                            <EditIcon sx={{ width: 16, height: 16 }} />
                            <HiddenInput
                                ref={fileRef}
                                type="file"
                                onChange={handleAvatar}
                            />
                        </IconButton>
                    </AvatarWrapper>
                </div>
                <Typography color="#E7E3D8" fontSize="14px">
                    You can change your username once every day
                </Typography>
                <FormControl variant="standard">
                    <InputLabel shrink>Username</InputLabel>
                    <BootstrapInput
                        fullWidth
                        placeholder="Your name is here"
                        value={userName ?? userInfo?.username ?? ""}
                        onChange={(e: any) => setUserName(e.target.value)}
                    />
                </FormControl>
                <FormControl variant="standard">
                    <InputLabel shrink>Bio</InputLabel>
                    <BootstrapInput
                        fullWidth
                        placeholder="Your bio is here"
                        value={userBio ?? userInfo?.bio ?? ""}
                        onChange={(e: any) => setUserBio(e.target.value)}
                    />
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleSaveProfile}
                    fullWidth
                    disabled={loading === "profile"}
                    endIcon={
                        loading === "profile" ? (
                            <CircularProgress color="inherit" size={14} />
                        ) : undefined
                    }
                >
                    {loading === "profile" ? "Saving" : "Save"}
                </Button>
            </DialogActions>
        </Dialog>
        {/* {
            !!deployedToken &&
            <FitDialog
                open={modal === 'deployed'}
                // TransitionComponent={Transition}
                onClose={() => setModal(undefined)}
                aria-describedby="dialogTokenCreated"
            >
                <DialogTitle>{"🚀 Token created!"}</DialogTitle>
                <DialogContent>
                    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                        <Typography fontFamily="Arial" fontSize={14} color="white">
                            Your memecoin ${deployedToken.tokenSymbol} is now live on ETH.
                        </Typography>
                        <Typography fontFamily="Arial" fontSize={14} color="white">
                            Share it, shill it, and let it moon 🌕
                        </Typography>
                        <Box display="flex" gap="16px" mt={2}>
                            <Avatar sx={{ width: 135, height: 135, borderRadius: '16px' }} src={avatar}>
                                <DollarIcon sx={{ color: 'white', width: 48, height: 48 }} />
                            </Avatar>
                            <Box display="flex" flexDirection="column" gap="0.2rem" justifyContent="center">
                                <Box display="flex" alignItems="baseline" gap="1rem">
                                    <Typography fontFamily="Arial" fontSize={14} color="white">Token name:</Typography>
                                    <Typography fontSize={16} fontFamily="Arial" fontWeight="bold" color="white">{deployedToken.tokenName}</Typography>
                                </Box>
                                <Box display="flex" alignItems="baseline" gap="1rem">
                                    <Typography fontFamily="Arial" fontSize={14} color="white">Token ticker:</Typography>
                                    <Typography fontSize={16} fontFamily="Arial" fontWeight="bold" color="white">{deployedToken.tokenSymbol}</Typography>
                                </Box>
                                <Box display="flex" alignItems="baseline" gap="1rem">
                                    <Typography fontFamily="Arial" fontSize={14} color="white">Total supply:</Typography>
                                    <Typography fontSize={16} fontFamily="Arial" fontWeight="bold" color="white">1,000,000,000</Typography>
                                </Box>
                                <Box display="flex" alignItems="baseline" gap="8px">
                                    <Typography fontFamily="Arial" fontSize={14} color="white">Address:</Typography>
                                    <Typography fontSize={14} color="white">{deployedToken.tokenAddress?.slice(0, 6)}...{deployedToken.tokenAddress?.slice(-4)}</Typography>
                                    <IconButton sx={{ width: 'fit-content', p: 0 }} onClick={() => copy(deployedToken.tokenAddress ?? '')}>
                                        <CopyIcon sx={{ color: "white", width: 14, height: 14 }} />
                                    </IconButton>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Link to={`/${deployedToken.network}/${deployedToken.tokenAddress}`} style={{ width: '100%', color: 'white', textDecoration: 'none', display: 'flex', alignItems: 'center', margin: 'auto' }}>
                        <ArrowLeftIcon />
                        <Typography fontFamily="Arial" fontSize={14} color="white">Token page</Typography>
                    </Link>
                </DialogActions>
            </FitDialog>
        } */}
    </div>
}